import { snapshotToSlotState } from './game/slotEngine.js';

export const SLOT_RECEIVER_KEY_MAP = {
  10: 'StarTax10',
  100: 'StarTax100',
  1000: 'StarTax1K',
  10000: 'StarTax10K',
  100000: 'StarTax100K',
  1000000: 'StarTax1M',
};

export function buildSlotSnapshot({ transactionCounter = 0, currentReceivers = {} }) {
  const mappedReceivers = {};

  for (const [slotKey, receiverKey] of Object.entries(SLOT_RECEIVER_KEY_MAP)) {
    mappedReceivers[slotKey] = currentReceivers?.[receiverKey] || null;
  }

  return {
    transactionCounter: Number(transactionCounter || 0),
    currentReceivers: mappedReceivers,
  };
}

export function buildSlotState({ transactionCounter, currentReceivers, walletAddress, previousState, revealOnInitialActive = false, initialRevealReason = null }) {
  return snapshotToSlotState({
    snapshot: buildSlotSnapshot({ transactionCounter, currentReceivers }),
    walletAddress,
    previousState,
    revealOnInitialActive,
    initialRevealReason,
  });
}
